import Box from "@mui/material/Box";
import React from "react";
import Header from "../components/Header";

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          marginTop: 5,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;
